import React from "react";
import { useFormContext } from "react-hook-form";
import { FormBuilder } from "components/FormBuilder";
import useFormDataFormatter from "hooks/useFormDataFormatter";

const Form = ({
  formContent,
  children = [],
  handleSubmit,
  experimentVariation = "0",
  onChange = () => {},
}) => {
  const methods = useFormContext();

  const formData = useFormDataFormatter(formContent);

  const formGroups = FormBuilder(formData, methods, experimentVariation ?? "0");

  /* eslint react/no-unknown-property: "off" */
  return (
    <form
      noValidate
      autoComplete="off"
      onSubmit={methods.handleSubmit(handleSubmit)}
      {...(onChange ? { onChange } : {})}
      error={methods.errors}
      className="form"
    >
      {children}
      {formGroups}
    </form>
  );
};
export default Form;
